module.exports = __webpack_public_path__ + "img/omer2.3f880a14.png";